<div class="chart-section">
  <div class="section-header">
    <div class="section-icon demography">
      <i class="bi bi-people"></i>
    </div>
    <h2 class="section-title">Audience Demographics</h2>
  </div>

  <div class="section-card">
    <app-loader *ngIf="!(profileState | async).loader['audit']['audience_tiktok']" size="sm" message="Analyzing demographics..."></app-loader>

    <div [class.dimmed]="!(profileState | async).loader['audit']['audience_tiktok']">
      <div class="chart-grid" *ngIf="chartsAudience !== undefined">
        <!-- Gender -->
        <div class="chart-cell">
          <div class="chart-cell-header">
            <h3>
              <i class="bi bi-gender-ambiguous cell-icon text-purple"></i>
              Gender
              <a class="info-tip" data-tooltip="Sex - followers' analysis"><i class="bi bi-info-circle"></i></a>
            </h3>
          </div>
          <div class="chart-with-legend">
            <div class="chart-pie-area">
              <div [chart]="chartsAudience[0]"></div>
            </div>
            <div class="chart-legend-area">
              <app-pie-legend [data]="chartsAudience[0]"></app-pie-legend>
            </div>
          </div>
        </div>

        <!-- Age -->
        <div class="chart-cell">
          <div class="chart-cell-header">
            <h3>
              <i class="bi bi-calendar-heart cell-icon text-coral"></i>
              Age
              <a class="info-tip" data-tooltip="Age - followers' age"><i class="bi bi-info-circle"></i></a>
            </h3>
          </div>
          <div [chart]="chartsAudience[1]"></div>
        </div>

        <!-- Quality Distribution -->
        <div class="chart-cell">
          <div class="chart-cell-header">
            <h3>
              <i class="bi bi-shield-check cell-icon text-green"></i>
              Quality Distribution
              <a class="info-tip" data-tooltip="Followers distribution in terms of how many people they follow"><i class="bi bi-info-circle"></i></a>
            </h3>
            <p class="chart-sub">by numbers of other profiles followed</p>
          </div>
          <div class="chart-with-legend">
            <div class="chart-pie-area">
              <div [chart]="chartsAudience[3]"></div>
            </div>
            <div class="chart-legend-area">
              <app-pie-legend [data]="chartsAudience[3]"></app-pie-legend>
            </div>
          </div>
        </div>

        <!-- Language -->
        <div class="chart-cell">
          <div class="chart-cell-header">
            <h3>
              <i class="bi bi-translate cell-icon text-blue"></i>
              Language
              <a class="info-tip" data-tooltip="The dominant language spoken by followers"><i class="bi bi-info-circle"></i></a>
            </h3>
          </div>
          <div [chart]="chartsAudience[2]"></div>
        </div>
      </div>
    </div>
  </div>
</div>
